<template>
  <div class="container">
    <div class="row">
      <div class="col-xs-6">
        <help-text>
          <h3>
            Details
          </h3>

          <p>
            Edit the details of the publication.
          </p>
        </help-text>
      </div>

      <div class="col-xs-18">
        <div class="panel panel-default">
          <div class="panel-body">
            <form @submit.prevent="submit" class="form-horizontal">
              <text-form-group
                  v-model="data.name"
                  name="name"
                  label="Name"
                  help-text="The name of the publication."
                  :error="getError('name')"
              ></text-form-group>

              <text-form-group
                  v-model="data.theme"
                  name="theme"
                  label="Theme"
                  help-text="The theme of the publication."
                  :error="getError('theme')"
              ></text-form-group>

              <textarea-form-group
                  v-model="data.theme_description"
                  name="theme_description"
                  label="Theme Description"
                  help-text="The description of the publication's theme."
                  :error="getError('theme_description')"
              ></textarea-form-group>

              <text-form-group
                  v-model="data.target"
                  name="target"
                  label="Target"
                  help-text="The sales target for the publication."
                  :error="getError('target')"
              ></text-form-group>

              <text-form-group
                  v-model="data.management_target"
                  name="management_target"
                  label="Management Target"
                  help-text="The management sales target for the publication."
                  :error="getError('management_target')"
              ></text-form-group>

              <date-form-group
                  v-model="data.publish_at"
                  name="publish_at"
                  label="Publish At"
                  help-text="The date that the publication is published."
                  :error="getError('publish_at')"
                  format="DD.MM.YYYY"
              ></date-form-group>

              <date-form-group
                  v-model="data.content_deadline_at"
                  name="content_deadline_at"
                  label="Content Deadline At"
                  help-text="The deadline for receiving content for the ad."
                  :error="getError('content_deadline_at')"
                  format="DD.MM.YYYY"
              ></date-form-group>

              <date-form-group
                  v-model="data.content_deadline_reminder_at"
                  name="content_deadline_reminder_at"
                  label="Content Deadline Reminder At"
                  help-text="The date that the reminders for submitting ad content should be sent out."
                  :error="getError('publish_at')"
                  format="DD.MM.YYYY"
              ></date-form-group>

              <hr>

              <submit-form-group button-class="btn-black"></submit-form-group>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import moment from 'moment'
import notify from '@/notify'
import DateFormGroup from '@/vendor/forms/FormGroups/Horizontal/Date'
import Errors from '@/mixins/Errors'
import HelpText from '@/components/HelpText'
import SubmitFormGroup from '@/vendor/forms/FormGroups/Horizontal/Submit'
import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'
import TextareaFormGroup from '@/vendor/forms/FormGroups/Horizontal/Textarea'

export default {
  components: {DateFormGroup, HelpText, SubmitFormGroup, TextFormGroup, TextareaFormGroup},

  mixins: [Errors],

  model: {
    prop: 'publication',
    event: 'publication-updated'
  },

  props: ['publication'],

  data() {
    return {
      data: {...this.publication.attributes}
    }
  },

  watch: {
    'data.publish_at'(value) {
      this.data.content_deadline_at = moment(value)
          .subtract(this.publication.attributes.publication_channel_default_content_deadline_period, 'days')
          .format('YYYY-MM-DD')
    },

    'data.content_deadline_at'(value) {
      this.data.content_deadline_reminder_at = moment(value)
          .subtract(this.publication.attributes.publication_channel_default_content_deadline_reminder_period, 'days')
          .format('YYYY-MM-DD')
    }
  },

  methods: {
    submit() {
      http.put('/api/v2/publications/' + this.publication.id, this.data)
          .then(response => {
            notify.success('The publication was saved')

            this.errors = {}

            this.$emit('publication-updated', response.data.data)
          })
          .catch(this.catchValidationErrors)
    }
  }
}
</script>
